// Vendored from quill-languagetool v1.0.7 — adapted for Quill v2
export default function debug(...args: any[]) {
  // Only log in development
  try {
    if (typeof process !== "undefined" && process.env && process.env["NODE_ENV"] !== "production") {
      console.debug("QuillLanguageTool", ...args);
    }
  } catch {
    // Silently ignore if process is not available
  }
}
